import React from 'react';

// Shimmering placeholder grid shown while a search mode is loading, so the
// Suppliers ↔ Products toggle feels smooth instead of flashing empty space.
function SearchSkeleton({
  count = 8,
  columnClass = 'is-full-mobile is-one-third-tablet is-one-quarter-desktop',
}) {
  return (
    <div className="columns is-mobile is-multiline search-skeleton" aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={`column ${columnClass}`}>
          <div className="supplierCard">
            <div className="supplierCardLogo skeleton-block"></div>
            <div className="skeleton-line skeleton-line--wide"></div>
            <div className="skeleton-line"></div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SearchSkeleton;
